import {createAction} from '@reduxjs/toolkit';

export const clearError = createAction('CLEAR_SETUP_ERROR');
export const clearData = createAction('CLEAR_SETUP_DATA');
export const clearRanges = createAction('CLEAR_SETUP_RANGES');
